import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';

import Root from 'root';
import { initSentry } from 'sentry';

initSentry();

ReactDOM.render(<Root />, document.getElementById('root'));
